import DOMPurify from 'dompurify';

export class BetterHTMLSanitizer {
  sanitize(input) {
    return "<!--sanitized-->"
      + DOMPurify.sanitize(input)
      + "<!--/sanitized-->";
  }
}